import NonWorkingDays from "@/models/Shared/NonWorkingDays";

export default (nonWorkingDays: NonWorkingDays) => {
    let returnVal = "Undefined";
    switch (nonWorkingDays) {
        case NonWorkingDays.NextWorkingDay:
            returnVal = "Next Working Day";
            break;
        case NonWorkingDays.PreviousWorkingDay:
            returnVal = "Previous Working Day";
            break;
        case NonWorkingDays.DoNotReschedule:
            returnVal = "Do Not Reschedule";
            break;
    }
    return returnVal;
}